import {createAction} from 'redux-starter-kit';

export const clearErrorNotification = createAction("clearErrorNotification");
export const setEventNotification = createAction("setEventNotification");




